<template>
  <div id="package-select"
       class="package-select"
  >
    <div class="tariff-container"
         :class="'tariff-container__count-elem_' + listTariff.length"
    >
      <div class="tariff-wrapper block__desktop"
           :class="{
             'tariff-wrapper__active': valueActiveTariff === item.id,
           }"
           v-for="(item, i) in listTariff"
           :key="'tariff_' + item.id"
           @click="selectTariff(item.id, i)"
      >
        <span class="text text__h3">{{ item.title }}</span>
        <span class="text text__h6 text__color_grey">{{ item.description }}</span>
      </div>

      <swiper class="swiper tariff-swiper block__mobile"
              :slidesPerView="'auto'"
              :spaceBetween="0"
              :pagination="false"
      >
        <swiper-slide class="tariff-slide"
                      v-for="(item, i) in listTariff"
                      :key="'tariff_' + item.id"
        >
          <div class="tariff-wrapper"
               :class="{
                         'tariff-wrapper__active': valueActiveTariff === item.id,
                       }"
               @click="selectTariff(item.id, i)"
          >
            <span class="text text__h3">{{ item.title }}</span>
            <span class="text text__h6 text__color_grey">{{ item.description }}</span>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <div class="package-container">
      <div class="package-wrapper"
           :class="{
             'package-wrapper__active': valueActivePackage === item.id,
           }"
           v-for="(item, i) in getListPackage"
           :key="'package_' + item.id"
           @click="selectPackage(item, i)"
      >
        <div class="package-wrapper_main">
          <span class="text text__h6">{{ item.countLessonText }}</span>
          <span class="text text__h3">{{ `${item[activeTypeTutor].costText} ₽` }}</span>
        </div>

        <div class="package-wrapper_additional"
             v-if="item.countPrize && (item.countPrize > 0)"
        >
          <div class="prize"
               @mouseenter="idShowPrizeModal = item.id"
               @mouseleave="idShowPrizeModal = null"
          >
            <div class="svg">
              <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.76367 10.0013H3.93034V16.668C3.93034 17.11 4.10593 17.5339 4.41849 17.8465C4.73105 18.159 5.15498 18.3346 5.59701 18.3346H9.76367V10.0013H4.76367ZM15.597 10.0013H11.4303V18.3346H15.597C16.039 18.3346 16.463 18.159 16.7755 17.8465C17.0881 17.5339 17.2637 17.11 17.2637 16.668V10.0013H15.597ZM16.2562 5.83464C16.3784 5.42945 16.4371 5.00779 16.4303 4.58464C16.4303 2.9763 15.122 1.66797 13.5137 1.66797C12.162 1.66797 11.2595 2.90297 10.677 4.2388C10.1028 2.9763 9.15451 1.66797 7.68034 1.66797C6.07201 1.66797 4.76367 2.9763 4.76367 4.58464C4.76367 5.0813 4.82951 5.49214 4.93784 5.83464H2.26367V9.16797H9.76367V7.5013H11.4303V9.16797H18.9303V5.83464H16.2562ZM6.43034 4.58464C6.43034 3.89547 6.99117 3.33464 7.68034 3.33464C8.42034 3.33464 9.10867 4.60547 9.512 5.83464H7.26367C6.952 5.83464 6.43034 5.83464 6.43034 4.58464ZM13.5137 3.33464C14.2028 3.33464 14.7637 3.89547 14.7637 4.58464C14.7637 5.83464 14.242 5.83464 13.9303 5.83464H11.8662C12.2912 4.5213 12.9087 3.33464 13.5137 3.33464Z" fill="#8C71FE"/>
              </svg>
            </div>

            <span class="text text__h6 text__purple">{{ item.countPrizeText }}</span>

            <transition name="fade">
              <div class="info-modal"
                   v-if="idShowPrizeModal === item.id"
              >
                <ul>
                  <li class="text"
                      v-for="prizeId in item.prizeIds"
                      :key="prizeId"
                  >
                    {{ listPrize[prizeId] }}
                  </li>
                </ul>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';

export default {
  name: "PackageSelect",

  props: {
    activeTariff: { // id активного тарифа
      type: Number,
      default: 0,
    },

    activePackage: { // id активного пакета
      type: Number,
      default: 0,
    },

    activeTypeTutor: { // активный тип репетиторов
      type: String,
      default: () => {
        return 'topTutor'
      }
    },

    listTariff: { // массив тарифов
      type: Array,
      default: () => {
        return []
      }
    },

    listPrize: { // объект бонусов
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  data() {
    return {
      idShowPrizeModal: null,
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        pagination: {
          clickable: true
        }
      },
    }
  },

  created() {

  },

  mounted() {
    console.log('getListPackage', this.getListPackage);
    console.log('activeTypeTutor', this.activeTypeTutor);
  },

  methods: {
    /** Выбрать тариф
     * @param {Number} id - id выбираемого тарифа
     * @param {Number} i - индекс выбираемого тарифа
    * */
    selectTariff(id, i) {
      if (this.valueActiveTariff !== id) {
        const indexActivePackage = this.getIndexActivePackage();
        this.$emit('selectTariff', id, i);

        if ((indexActivePackage !== null) && this.listTariff[i].listPackage[indexActivePackage]) {
          this.selectPackage(this.listTariff[i].listPackage[indexActivePackage], indexActivePackage);
        } else {
          this.selectPackage(this.listTariff[i].listPackage[0], 0);
        }
      }
    },

    /** Выбрать пакета
     * @param {Object} item - объект выбираемого пакета
     * @param {Number} i - индекс выбираемого тарифа
     * */
    selectPackage(item, i) {
      if (this.valueActivePackage !== item.id) {
        this.$emit('selectPackage', item, i);
      }
    },

    /** Получить index активного пакета
     * @returns {Number} index активного пакета
     * */
    getIndexActivePackage() {
      for (let item of this.listTariff) {
        if (item.id === this.valueActiveTariff) {
          for (const [index, value] of item.listPackage.entries()) {
            if (value.id === this.valueActivePackage) {
              return index;
            }
          }
          break;
        }
      }

      return null;
    },
  },

  computed: {
    /** Управляет id выбранного тарифа
    * */
    valueActiveTariff: {
      get() {
        return this.activeTariff
      },

      set(value) {
        this.$emit('update:activeTariff', value);
      },
    },

    /** Управляет id выбранного пакета
     * */
    valueActivePackage: {
      get() {
        return this.activePackage
      },

      set(value) {
        this.$emit('update:activePackage', value);
      },
    },

    /** Получить список пакетов
     * @returns {Array} список пакетов
    * */
    getListPackage() {
      for (let item of this.listTariff) {
        if (item.id === this.activeTariff) return item.listPackage;
      }

      return [];
    },
  },

  components: {
    Swiper,
    SwiperSlide,
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../style/variables";

#package-select {
  .block__desktop {
    display: grid;
  }

  .block__mobile {
    display: none;
  }

  .info-modal li {
    color: $color_black;
  }

  .prize .text__purple {
    margin-top: 1px;
    color: $color_purple_3;
  }
}

.package-select {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 32px;
  max-width: 1032px;
  width: 100%;
}

.tariff-container {
  display: grid;
  grid-gap: 0;
  align-items: center;
}

.tariff-container__count-elem_4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.tariff-container__count-elem_3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.tariff-container__count-elem_2, .tariff-container__count-elem_1 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.tariff-wrapper, .package-wrapper {
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  transition: $transition_medium;
  cursor: pointer;

  &:hover {
    background-color: $color_purple_3;

    .text {
      color: white;
    }
  }
}

.tariff-wrapper {
  height: calc(100% - 34px);
  padding: 17px 24px;

  .text__h6 {
    margin-top: 2px;
  }
}

.tariff-wrapper__active, .package-wrapper__active {
  cursor: default;
  background-color: $color_purple_3;
  border-color: $color_purple_3;

  .text {
    color: white;
  }

  .prize {
    .text {
      color: $color_purple_3;
    }
  }
}

.package-container {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  grid-gap: 32px;
  align-items: center;
}

.package-wrapper {
  border: 1px solid $color_grey_bg_2;
  padding: 24px;
  height: auto;

  .text__h3:not(:first-child), .text__h6:not(:first-child) {
    margin-top: 2px;
  }
}

.package-wrapper_main, .package-wrapper_additional {
  display: flex;
  flex-direction: column;
}

.package-wrapper_additional {
  margin-top: 24px;
}

.text__color_grey {
  color: $color_grey_3;
}

.text__h3 {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 23px;
}

.text__h6 {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
}

.text__h5 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 19px;
}

.text__purple {
  color: $color_purple_3;
}

.text {
  transition: $transition_medium;
}

.svg {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.prize {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 32px;
  background-color: $color_purple_bg_2;
  border-radius: 8px;
  position: relative;

  .text {
    margin-left: 6px;
  }
}

.info-modal {
  display: flex;
  flex-direction: column;
  background-color: white;
  z-index: 2;
  padding: 14px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0px 6px 8px -6px rgba(24, 39, 75, 0.12), 0px 8px 16px -6px rgba(24, 39, 75, 0.08);
  border-radius: 8px;
  cursor: default;
  position: absolute;
  top: 32px;
  left: 0;
  max-width: 540px;
  width: max-content;

  ul {
    list-style-type: disc;
    margin: 0;
    padding: 0 0 0 8px;
  }

  li {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    color: $color_black;
  }
}

@media all and (max-width: 1700px) {
 /* .package-container {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }*/

  .package-container {
    grid-gap: 28px;
  }

  .tariff-wrapper {
    height: calc(100% - 34px);
    padding: 17px 20px;
  }

  .package-wrapper {
    border: 1px solid #F2F2F2;
    padding: 20px;
  }

  .package-wrapper_additional {
    margin-top: 20px;
  }
}

@media all and (max-width: 1600px) {
  .package-select {
    grid-gap: 28px;
  }

  .tariff-container__count-elem_4 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media all and (max-width: 1440px) {
  .tariff-wrapper {
    height: calc(100% - 34px);
    padding: 17px 18px;
  }

  .package-wrapper {
    padding: 18px;
  }

  .package-select {
    grid-gap: 24px;
  }

  .package-container {
    grid-gap: 24px;
  }

  .tariff-wrapper, .package-wrapper {
    border-radius: 10px;
  }

  .text__h3 {
    font-size: 17px;
    line-height: 21px;
  }

  .text__h6 {
    font-size: 13px;
    line-height: 16px;
  }

  .package-wrapper_additional {
    margin-top: 18px;
  }

  .text__h5 {
    font-size: 14px;
    line-height: 18px;
  }

  .prize {
    height: 30px;
    border-radius: 4px;

    .svg svg {
      width: 18px;
      height: 18px;
    }
  }

  .info-modal {
    padding: 14px;
    border-radius: 4px;
    top: 30px;
    max-width: 500px;

    li {
      font-size: 15px;
      line-height: 19px;
    }
  }
}

@media all and (max-width: 1280px) {
  .package-container {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media all and (max-width: 1200px) {
  .info-modal {
    max-width: 380px;
  }
}

@media all and (max-width: 1160px) {
  .package-container {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .tariff-wrapper, .package-wrapper {
    &:hover {
      background-color: white;

      .text {
        color: $color_black;
      }

      .text__color_grey {
        color: $color_grey_3;
      }
    }
  }

  .tariff-wrapper__active, .package-wrapper__active {
    &:hover {
      background-color: $color_purple_3;
      border-color: $color_purple_3;

      .text {
        color: white;
      }
    }
  }

  .package-wrapper:nth-child(5n), .package-wrapper:nth-child(5n - 1) {
    .info-modal {
      right: 0;
      left: auto;
    }
  }
}

@media all and (max-width: 960px) {
  .package-container {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .package-wrapper:nth-child(5n), .package-wrapper:nth-child(5n - 1) {
    .info-modal {
      left: 0;
      right: auto;
    }
  }

  .package-wrapper:nth-child(4n), .package-wrapper:nth-child(4n - 1) {
    .info-modal {
      right: 0;
      left: auto;
    }
  }
}

@media all and (max-width: 720px) {
  .package-container {
    grid-gap: 20px;
  }

  .package-select {
    grid-gap: 20px;
  }

  .package-container {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .package-wrapper:nth-child(4n), .package-wrapper:nth-child(4n - 1) {
    .info-modal {
      left: 0;
      right: auto;
    }
  }

  .package-wrapper:nth-child(3n) {
    .info-modal {
      right: 0;
      left: auto;
    }
  }

  .info-modal {
    max-width: 320px;
  }
}

// mobile
@media all and (max-width: 600px) {
  #package-select {
    .block__desktop {
      display: none;
    }

    .block__mobile {
      display: block;
    }
  }

  .tariff-container {
    display: flex;
    flex-direction: row;
    grid-gap: 0;
    align-items: center;
    margin: 0 -15px;
    width: calc(100% + 30px);
    overflow: hidden;
  }

  .tariff-wrapper, .package-wrapper {
    border-radius: 8px;
  }

  .tariff-slide {
    display: flex;
    flex-direction: row;
    width: fit-content;
    height: auto;

    &:first-child {
      margin-left: 15px;
    }

    &:last-child {
      .tariff-wrapper {
        margin-right: 16px;
      }
    }

    &:not(:first-child) {
      .tariff-wrapper {
        margin-left: 16px;
      }
    }
  }

  .tariff-wrapper {
    height: 100%;
    padding: 17px 16px;
    width: 244px;
    border: 1px solid $color_grey_bg_3;
    background-color: white;
    box-sizing: border-box;
  }

  .package-wrapper {
    padding: 16px;
    border: 1px solid $color_grey_bg_3;
    background-color: white;
  }

  .tariff-wrapper__active, .package-wrapper__active {
    cursor: default;
    background-color: $color_purple_3;
    border-color: $color_purple_3;

    .text {
      color: white;
    }
  }

  .package-select {
    grid-gap: 16px;
  }

  .package-container {
    grid-gap: 16px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .text__h6 {
    font-size: 12px;
    line-height: 15px;
  }

  .text__h3 {
    font-size: 16px;
    line-height: 20px;
  }

  .text__h5 {
    font-size: 13px;
    line-height: 16px;
  }

  .package-wrapper_additional {
    margin-top: 16px;
  }

  .package-wrapper:nth-child(3n) {
    .info-modal {
      left: 0;
      right: auto;
    }
  }

  .package-wrapper:nth-child(2n - 1) {
    .info-modal {
      left: -17px;
      right: auto;
    }
  }

  .package-wrapper:nth-child(2n) {
    .info-modal {
      right: -17px;
      left: auto;
    }
  }

  .info-modal {
    padding: 12px;
    max-width: 300px;

    li {
      font-size: 14px;
      line-height: 18px;
    }
  }
}

@media all and (max-width: 380px) {
  .info-modal {
    max-width: 280px;
  }
}

@media all and (max-width: 360px) {
  .tariff-wrapper {
    width: 224px;
  }

  .info-modal {
    max-width: 260px;
  }
}

@media all and (max-width: 340px) {
  .tariff-wrapper {
    width: 214px;
  }
}
</style>